import { render, staticRenderFns } from "./CreditBalance.vue?vue&type=template&id=5328db8b&"
import script from "./CreditBalance.vue?vue&type=script&lang=js&"
export * from "./CreditBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports